class MinerwaGallery extends HTMLElement {
  connectedCallback() {
    this.videos = [...this.querySelectorAll('video')];

    this.revealObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.revealed = 'true';
        this.revealObserver.disconnect();
      },
      { rootMargin: '-50px' },
    );
    this.revealObserver.observe(this);

    if (this.videos.length > 0) {
      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              if (video.preload === 'none') video.preload = 'auto';
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2 },
      );
      this.videos.forEach((video) => this.videoObserver.observe(video));
    }
  }

  disconnectedCallback() {
    this.revealObserver?.disconnect();
    this.videoObserver?.disconnect();
  }
}

if (!customElements.get('minerwa-gallery')) {
  customElements.define('minerwa-gallery', MinerwaGallery);
}
